import { render } from "./Home.vue?vue&type=template&id=bc3c5e36&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=bc3c5e36&scoped=true&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps-v2/packages/frontendscanning/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc3c5e36"]])

export default __exports__